import { useNavigate } from "react-router-dom";
import MobileHeader from "../../component/MobileHeader";
import "../../css/diagnostic/datelist.css";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import flatpickr from "flatpickr";
import { Korean } from "flatpickr/dist/l10n/ko.js";
import "flatpickr/dist/flatpickr.min.css";

export default function DateList() {
    const navigate = useNavigate();
    const API = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("accessToken") || "";

    const [userInfo, setUserInfo] = useState({
        regId: "",
        regNM: "",
        aboveNM: "",
        fldIdx: "",
        fldNM: "",
    });

    const [userFldIdx, setUserFldIdx] = useState("");
    const [dateList, setDateList] = useState([]);
    const [dateType, setDateType] = useState("inspection");

    const days = ["일", "월", "화", "수", "목", "금", "토"];
    const dateInputRef = useRef(null);

    useEffect(() => {
        axios
            .get(`${API}/userinf`, {
                headers: { Authorization: token },
            })
            .then((res) => {
                const data = res.data || {};
                const fldIdxValue = data.fldIdx ?? "";

                setUserInfo({
                    regId: data.regId || data.userId || data.uid || "",
                    regNM: data.regNM || data.userName || "",
                    aboveNM: data.aboveContractor?.aboveNM || data.aboveNM || "",
                    fldIdx: fldIdxValue,
                    fldNM: data.field?.fldNM || data.fldNM || "",
                });

                setUserFldIdx(String(fldIdxValue));
            })
            .catch((err) => {
                console.error("userinf error:", err?.response?.status, err?.response?.data);
                setUserInfo({
                    regId: "",
                    regNM: "",
                    aboveNM: "",
                    fldIdx: "",
                    fldNM: "",
                });
                setUserFldIdx("");
            });
    }, [API, token]);

    useEffect(() => {
        if (!dateInputRef.current) return;

        const container = dateInputRef.current.parentElement;

        const fp = flatpickr(dateInputRef.current, {
            locale: Korean,
            clickOpens: true,
            allowInput: false,
            dateFormat: "Y-m-d",
            static: true,
            appendTo: container,
            disableMobile: true,
            onChange: (_, dateStr) => {
                if (!dateStr || !userFldIdx) return;

                navigate(
                    `/list?fldIdx=${encodeURIComponent(userFldIdx)}&targetDate=${encodeURIComponent(
                        dateStr
                    )}&dateType=${encodeURIComponent(dateType)}`
                );
            },
        });

        return () => fp.destroy();
    }, [navigate, userFldIdx, dateType]);

    useEffect(() => {
        if (dateInputRef.current?._flatpickr) {
            dateInputRef.current._flatpickr.clear();
        }
    }, [dateType]);

    useEffect(() => {
        if (!userFldIdx) return;

        axios
            .get(`${API}/selectDate`, {
                params: {
                    fldIdx: userFldIdx,
                    dateType,
                },
                headers: {
                    "Content-type": "application/json",
                    Authorization: token,
                },
            })
            .then((resp) => {
                setDateList(Array.isArray(resp.data) ? resp.data : []);
            })
            .catch((err) => {
                console.error("selectDate error:", err?.response?.status, err?.response?.data);
                setDateList([]);
            });
    }, [API, token, userFldIdx, dateType]);

    const handleMoveDate = (date) => {
        if (!userFldIdx) return;

        navigate(
            `/list?fldIdx=${encodeURIComponent(userFldIdx)}&targetDate=${encodeURIComponent(
                date
            )}&dateType=${encodeURIComponent(dateType)}`
        );
    };

    return (
        <div className="page">
            <div className="date_mobile">
                <MobileHeader onPrev={() => window.history.back()} />

                <main className="main">
                    <h1 className="title">점검 현황</h1>
                    <p className="sub_title">
                        조회할 날짜를 선택해주세요.
                        <br />
                        아래 목록 또는 달력에서 바로 이동할 수 있습니다.
                    </p>

                    <section className="dl_card">
                        <div className="dl_section_head">
                            <h2>날짜 검색</h2>
                            <span>{dateType === "inspection" ? "점검일 기준" : "발생일 기준"}</span>
                        </div>

                        <div className="dl_date_type_toggle">
                            <button
                                type="button"
                                className={`dl_date_type_btn ${dateType === "inspection" ? "active" : ""}`}
                                onClick={() => setDateType("inspection")}
                            >
                                점검일로 선택
                            </button>

                            <button
                                type="button"
                                className={`dl_date_type_btn ${dateType === "occurrence" ? "active" : ""}`}
                                onClick={() => setDateType("occurrence")}
                            >
                                발생일로 선택
                            </button>
                        </div>

                        <div className="dl_searchbar">
                            <span
                                className="dl_search_icon"
                                onClick={() => dateInputRef.current?._flatpickr?.open()}
                            >
                                <img
                                    src="/images/달력 아이콘.png"
                                    width="20"
                                    height="20"
                                    alt="달력"
                                />
                            </span>

                            <input
                                ref={dateInputRef}
                                className="dl_calendar_input"
                                placeholder={
                                    dateType === "inspection"
                                        ? "점검일을 선택하세요"
                                        : "발생일을 선택하세요"
                                }
                                readOnly
                                onClick={() => dateInputRef.current?._flatpickr?.open()}
                            />
                        </div>
                    </section>

                    <section className="dl_card">
                        <div className="dl_section_head">
                            <h2>날짜 목록</h2>
                            <span>{dateList.length}건</span>
                        </div>

                        <div className="dl_list">
                            {dateList.length > 0 ? (
                                dateList.map((date, index) => {
                                    const weekday = days[new Date(date).getDay()];

                                    return (
                                        <button
                                            type="button"
                                            key={`${date}-${index}`}
                                            className="dl_date_item"
                                            onClick={() => handleMoveDate(date)}
                                        >
                                            <div className="dl_date_left">
                                                <div className="dl_date_icon">
                                                    <img
                                                        src="/images/달력 아이콘.png"
                                                        width="22"
                                                        height="22"
                                                        alt="달력"
                                                    />
                                                </div>

                                                <div className="dl_date_text_group">
                                                    <strong className="dl_date_text">{date}</strong>
                                                    <span className="dl_date_desc">
                                                        {dateType === "inspection"
                                                            ? "선택한 날짜의 점검 내역 보기"
                                                            : "선택한 날짜의 발생 내역 보기"}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="dl_date_right">
                                                <span className="dl_weekday">{weekday}요일</span>
                                                <span className="dl_arrow">›</span>
                                            </div>
                                        </button>
                                    );
                                })
                            ) : (
                                <div className="dl_empty">
                                    <div className="dl_empty_icon">📅</div>
                                    <p>조회 가능한 날짜가 없습니다.</p>
                                </div>
                            )}
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
}